import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowLeftS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11.7764 19.8078C11.4877 20.0675 11.053 20.0613 10.7715 19.8059L4.19435 12.5041C3.93 12.206 3.93 11.7817 4.1924 11.4983L10.7168 4.24826C10.9938 3.94051 11.4685 3.91588 11.7764 4.1926C12.0842 4.46971 12.1091 4.94433 11.832 5.25217L6.43361 11.2502L19.25 11.2502C19.6641 11.2502 19.9999 11.5861 20 12.0002C20 12.4144 19.6642 12.7502 19.25 12.7502L6.43361 12.7502L11.8799 18.8078C12.1046 19.1146 12.0651 19.548 11.7764 19.8078Z",
            fill: color
        })
    });

//# sourceMappingURL=arrow-left-s.js.map